import { createUpserter } from '@/app/shared/utils'
import { UpdateInteractionStateTrackingCommand, UpdateInteractionResultTrackingCommand } from '../api';
import { InteractionTrackingState, defaultInteractionTrackingState } from './interaction-state2'

export type InteractionsState = InteractionTrackingState[];
export type InteractionCommand = UpdateInteractionStateTrackingCommand | UpdateInteractionResultTrackingCommand;

const selectInsert = createUpserter<InteractionTrackingState>((id) => defaultInteractionTrackingState(id));

export function interactionStateReducer(state: InteractionsState, command: InteractionCommand) {
  switch (command.name) {
    case 'update-interaction-state': {
      const payload = command.payload;
      return selectInsert(state, payload.id, (item) => ({
        id: item.id,
        type: payload.type,
        state: payload.state,
        status: item.status,
        progress: item.progress
      }))
    }
    case 'update-interaction-result': {
      const payload = command.payload;
      return selectInsert(state, payload.id, (item) => ({
        id: item.id,
        type: payload.type,
        progress: payload.progress,
        status: payload.status,
        state: item.state
      }))
    }
  }
}
